<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : clientContract.pkId > 0 ? '编辑' : '新建'"
      width="1400px"
      class="adaptationModal"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="clientContract"
        :rules="ruleValidate"
        label-width="150px">
      <div class="editTitle">基本信息</div>
      <div v-if="!isBorrow">
        <el-row>
          <el-col :span="7">
            <el-form-item label="合同类型" prop="clientContractType">
              <el-select
                  v-model="clientContract.clientContractType"
                  :disabled="disabled || clientContract.pkId > 0"
                  @change="setIsCommon">
                <el-option label="产品销售合同" :value="30"/>
                <el-option label="渠道商协议" :value="10"/>
                <el-option label="框架合同" :value="20"/>
                <el-option label="产品借用转销售合同" :value="40"/>
                <el-option label="试用协议" :value="50"/>
                <el-option label="备品协议" :value="60"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="紧急程度" prop="urgent">
              <el-radio v-model="clientContract.urgent" label="正常" :disabled="disabled">正常</el-radio>
              <el-radio v-model="clientContract.urgent" label="紧急" :disabled="disabled">紧急</el-radio>
              <el-radio v-model="clientContract.urgent" label="重要" :disabled="disabled">重要</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="客户/渠道商名称" prop="customerName">
              <el-input v-model="clientContract.customerName" :disabled="disabled" placeholder="请选择客户/渠道商" readonly>
                <el-button
                    slot="append"
                    icon="el-icon-search"
                    :disabled="disabled"
                    @click="$refs.customerSelect.open()"/>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="销售员" prop="salesPersonName">
              <el-select
                  v-if="showSalesPersonSelect"
                  v-model="clientContract.salesPerson"
                  value-key="employeeID"
                  filterable
                  :disabled="!clientContract.customerName || disabled"
                  @change="onSelectEmployee">
                <el-option
                    v-for="value in salesPersonList"
                    :key="value.employeeID"
                    :label="value.employeeName"
                    :value="value"/>
              </el-select>
              <el-input
                  v-else
                  v-model="clientContract.salesPersonName"
                  :disabled="disabled"
                  placeholder="请选择销售员"
                  readonly>
                <el-button
                    slot="append"
                    icon="el-icon-search"
                    :disabled="!clientContract.customerName || disabled"
                    @click="$refs.employeeSelect.open()"/>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="销售员部门" prop="salesPersonDepartment">
              <el-input v-model="clientContract.salesPersonDepartment" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="抄送人员" prop="sendPeopleName">
              <el-input
                  v-model="clientContract.sendPeopleName"
                  clearable
                  :disabled="disabled"
                  placeholder="请选择抄送人员">
                <el-button
                    slot="append"
                    icon="el-icon-search"
                    :disabled="disabled"
                    @click="$refs.employeeSelect1.open()"/>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="申请人" prop="applicantName">
              <el-input
                  v-model="clientContract.applicantName"
                  :disabled="disabled"
                  placeholder="请选择申请人"
                  readonly>
                <el-button
                    slot="append"
                    icon="el-icon-search"
                    :disabled="disabled"
                    @click="$refs.applicantSelect.open()"/>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="申请日期" prop="createTime">
              <el-input v-model="clientContract.createTime" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="质保期" prop="warrantyPeriod">
              <el-input-number v-model="clientContract.warrantyPeriod" :min="0" :disabled="disabled"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="盖章份数" prop="stampQty">
              <el-input-number v-model="clientContract.stampQty" :min="0" :disabled="disabled"/>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="盖章方式" prop="stampType">
              <el-select v-model="clientContract.stampType" :disabled="disabled">
                <el-option label="电子用印" :value="117"/>
                <el-option label="物理用印" :value="118"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="clientContract.stampType === 117" :span="7">
            <el-form-item label="盖章情况">
              <el-select v-model="clientContract.stampNote" :disabled="disabled">
                <el-option label="双签，我司先盖章" :value="0"/>
                <el-option label="我司单独盖章" :value="2"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="clientContract.stampType === 118" :span="7">
            <el-form-item label="盖章次数">
              <el-input-number v-model="clientContract.stampNumber" :min="0" :disabled="disabled"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <span v-if="clientContract.stampNote === 0 && clientContract.stampType === 117" style="margin-left: 100px;color: red">此方式为对方也使用电子签，请确认对方已认证电子签，否则无法完成签署</span>
        </el-row>
      </div>
      <div v-if="isBorrow">
        <el-row>
          <el-col :span="7">
            <el-form-item label="合同类型" prop="clientContractType">
              <el-select
                  v-model="clientContract.clientContractType"
                  :disabled="disabled || clientContract.pkId > 0"
                  @change="setIsCommon">
                <el-option label="渠道商协议" :value="10"/>
                <el-option label="框架合同" :value="20"/>
                <el-option label="产品销售合同" :value="30"/>
                <el-option label="产品借用转销售合同" :value="40"/>
                <el-option label="试用协议" :value="50"/>
                <el-option label="备品协议" :value="60"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="客户/渠道商名称" prop="customerName">
              <el-input v-model="clientContract.customerName" :disabled="disabled" placeholder="请选择客户/渠道商" readonly>
                <el-button
                    slot="append"
                    icon="el-icon-search"
                    :disabled="disabled"
                    @click="$refs.customerSelect.open()"/>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="申请人" prop="applicantName">
              <el-input
                  v-model="clientContract.applicantName"
                  :disabled="disabled"
                  placeholder="请选择申请人"
                  readonly>
                <el-button
                    slot="append"
                    icon="el-icon-search"
                    :disabled="disabled"
                    @click="$refs.applicantSelect.open()"/>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="续借" prop="nextBorrow">
              <el-select v-model="clientContract.nextBorrow" :disabled="disabled">
                <el-option label="是" :value="true"/>
                <el-option label="否" :value="false"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="借用产品分类" prop="productTypeCode">
              <el-select v-model="clientContract.productTypeCode" :disabled="disabled" filterable>
                <el-option label="视觉产品" :value="18"/>
                <el-option label="系统" :value="22"/>
                <el-option label="伺服电机" :value="19"/>
                <el-option label="控制卡" :value="20"/>
                <el-option label="PAC控制器" :value="21"/>
                <el-option label="BU14泛电子智能产线" :value="12"/>
                <el-option label="工业机器人" :value="13"/>
                <el-option label="桌面型机器人" :value="14"/>
                <el-option label="编码器" :value="15"/>
                <el-option label="代理产品" :value="0"/>
                <el-option label="系统与方案" :value="11"/>
                <el-option label="辛格林纳Ω6" :value="1"/>
                <el-option label="辛格林纳EM/MS" :value="2"/>
                <el-option label="众为兴旋转/AP2/AN2" :value="3"/>
                <el-option label="佰匠IK3/AN1" :value="4"/>
                <el-option label="之山-通用" :value="5"/>
                <el-option label="之山-专机" :value="6"/>
                <el-option label="之山IK3/AN1" :value="7"/>
                <el-option label="之山其他产品" :value="8"/>
                <el-option label="众为兴直线伺服" :value="9"/>
                <el-option label="控制及集成" :value="10"/>
                <el-option label="SC20/SC30/SC50/控制卡" :value="16"/>
                <el-option label="CNC/点胶/植毛/弹簧/模板机" :value="17"/>
                <el-option label="关节模组" :value="23"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="试用品借用公司" prop="productTypeCode">
              <el-select v-model="clientContract.borrowCompanyCode" :disabled="disabled">
                <el-option label="机器人公司" :value="4"/>
                <el-option label="会通公司" :value="0"/>
                <el-option label="佰匠公司" :value="1"/>
                <el-option label="之山公司" :value="2"/>
                <el-option label="众为兴公司" :value="3"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="会签人" prop="countersignName">
              <el-input v-model="clientContract.countersignName" :disabled="disabled" placeholder="请选择会签人" readonly>
                <el-button
                    slot="append"
                    icon="el-icon-search"
                    :disabled="disabled"
                    @click="$refs.employeeSelect2.open()"/>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="所属PDT" prop="belongToPDTCode">
              <el-select v-model="clientContract.belongToPDTCode" :disabled="disabled">
                <el-option label="BU14泛电子智能产线" :value="3"/>
                <el-option label="工业机器人产品线" :value="4"/>
                <el-option label="桌面型机器人产品线" :value="5"/>
                <el-option label="代理业务" :value="0"/>
                <el-option label="国产运控产品线" :value="1"/>
                <el-option label="BU10控制及集成" :value="2"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="抄送人员" prop="sendPeopleName">
              <el-input
                  v-model="clientContract.sendPeopleName"
                  clearable
                  :disabled="disabled"
                  placeholder="请选择抄送人员">
                <el-button
                    slot="append"
                    icon="el-icon-search"
                    :disabled="disabled"
                    @click="$refs.employeeSelect1.open()"/>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="试用原因" prop="clientContractAbstract">
              <el-input
                  v-model="clientContract.clientContractAbstract"
                  :disabled="disabled"
                  placeholder=""
                  type="textarea"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="盖章份数" prop="stampQty">
              <el-input-number v-model="clientContract.stampQty" :min="0" :disabled="disabled"/>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="盖章方式" prop="stampType">
              <el-select v-model="clientContract.stampType" :disabled="disabled">
                <el-option label="电子用印" :value="117"/>
                <el-option label="物理用印" :value="118"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="clientContract.stampType === 117" :span="7">
            <el-form-item label="盖章情况">
              <el-select v-model="clientContract.stampNote" :disabled="disabled">
                <el-option label="双签，我司先盖章" :value="0"/>
                <el-option label="我司单独盖章" :value="2"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="clientContract.stampType === 118" :span="7">
            <el-form-item label="盖章次数">
              <el-input-number v-model="clientContract.stampNumber" :min="0" :disabled="disabled"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <span v-if="clientContract.stampNote === 0 && clientContract.stampType === 117" style="margin-left: 100px;color: red">此方式为对方也使用电子签，请确认对方已认证电子签，否则无法完成签署</span>
        </el-row>
      </div>
      <div class="editTitle">合同内容信息</div>
      <div v-if="clientContract.clientContractType===10">
        <el-row>
          <el-col :span="7">
            <el-form-item label="协议编号" prop="clientContractNo">
              <el-input v-model="clientContract.clientContractNo" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="协议所属公司" prop="belongToCustomerNo">
              <el-input v-model.trim="clientContract.belongToCustomerNo" :disabled="disabled"/>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="税号" prop="">
              <el-input v-model="clientContract.unifiedSocialCreditCode" :disabled="disabled"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="渠道商名称" prop="customerName">
              <el-input v-model="clientContract.customerName" :disabled="disabled" placeholder="请选择渠道商" readonly>
                <el-button
                    slot="append"
                    icon="el-icon-search"
                    :disabled="disabled"
                    @click="$refs.customerSelect.open()"/>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="渠道商类型" prop="customerType">
              <el-radio v-model="clientContract.customerType" label="经销商" :disabled="disabled">经销商</el-radio>
              <el-radio v-model="clientContract.customerType" label="系统集成商" :disabled="disabled">系统集成商</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="渠道商等级" prop="dealerLevel">
              <el-input v-model="clientContract.dealerLevel" disabled/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="协议金额" prop="clientContractAmount">
              <el-input v-model="clientContract.clientContractAmount" :disabled="disabled"/>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="协议金额(大写)" prop="clientContractAmountChinese">
              <el-input v-model="clientContract.clientContractAmountChinese" readonly/>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="信贷额度" prop="creditLimit">
              <el-input v-model="clientContract.creditLimit"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="区域范围" prop="province">
              <el-input v-model="clientContract.province" :disabled="disabled"/>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="销售对象产品" prop="salesTargetProduct">
              <el-input v-model="clientContract.salesTargetProduct" :disabled="disabled"/>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="特定行业" prop="specificIndustries">
              <el-input v-model="clientContract.specificIndustries" :disabled="disabled"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="最少专职销售人员" prop="customerSalesPeople">
              <el-input-number v-model="clientContract.customerSalesPeople" :min="0" :disabled="disabled"/>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="最少专职技术工程师" prop="customerEngineer">
              <el-input-number v-model="clientContract.customerEngineer" :min="0" :disabled="disabled"/>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="渠道商担保人" prop="customerGuarantor">
              <el-input v-model="clientContract.customerGuarantor" :disabled="disabled"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="担保人身份证号码" prop="guarantorIdNumber">
              <el-input v-model="clientContract.guarantorIdNumber" :disabled="disabled"/>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="担保人家庭住址" prop="guarantorAddress">
              <el-input v-model="clientContract.guarantorAddress" :disabled="disabled"/>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="担保人电话" prop="guarantorPhone">
              <el-input v-model="clientContract.guarantorPhone" :disabled="disabled"/>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div v-if="clientContract.clientContractType===20">
        <el-row>
          <el-col :span="7">
            <el-form-item label="合同编号" prop="clientContractNo">
              <el-input v-model="clientContract.clientContractNo" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="合同所属公司" prop="belongToCustomerNo">
              <el-input v-model.trim="clientContract.belongToCustomerNo" :disabled="disabled"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="客户名称" prop="customerName">
              <el-input v-model="clientContract.customerName" :disabled="disabled" placeholder="请选择客户" readonly>
                <el-button
                    slot="append"
                    icon="el-icon-search"
                    :disabled="disabled"
                    @click="$refs.customerSelect.open()"/>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="公司统一模板" prop="commonModel">
              <el-radio v-model="clientContract.commonModel" label="是" :disabled="disabled">是</el-radio>
              <el-radio v-model="clientContract.commonModel" label="否" :disabled="disabled">否</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="框架合同" prop="framework">
              <el-radio v-model="clientContract.framework" label="是" :disabled="disabled">是</el-radio>
              <el-radio v-model="clientContract.framework" label="否" :disabled="disabled">否</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="合同金额" prop="clientContractAmount">
              <el-input v-model="clientContract.clientContractAmount" :disabled="disabled"/>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="合同金额(大写)" prop="clientContractAmountChinese">
              <el-input v-model="clientContract.clientContractAmountChinese" readonly/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="21">
            <el-form-item label="合同内容摘要" prop="clientContractAbstract">
              <el-input v-model="clientContract.clientContractAbstract" type="textarea" :disabled="disabled"/>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div v-if="isCommon">
        <el-row>
          <el-col :span="7">
            <el-form-item label="合同编号" prop="clientContractNo">
              <el-input v-model="clientContract.clientContractNo" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="客户合同编号" prop="customerClientContractNo">
              <el-input v-model.trim="clientContract.customerClientContractNo" :disabled="disabled"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="付款方式" prop="paymentType">
              <el-select v-model="clientContract.settlementMethod" placeholder="请选择账期" :disabled="disabled" filterable>
                <el-option v-for="item in payMethods" :key="item.no" :value="item.no" :label="item.name"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="OEM/终端名称" prop="finalCustomerName">
              <el-input
                  v-model="clientContract.finalCustomerName"
                  :disabled="disabled"
                  placeholder="请选择OEM/终端"
                  readonly>
                <el-button
                    slot="append"
                    icon="el-icon-search"
                    :disabled="disabled"
                    @click="$refs.customerSelect1.open()"/>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div v-if="clientContract.clientContractType===50 || clientContract.clientContractType=== 60">
          <el-row>
            <el-col :span="7">
              <el-form-item label="试用时间" prop="borrowTimeCode">
                <el-select v-model="clientContract.borrowTimeCode" :disabled="disabled">
                  <el-option label="30天内" :value="0"/>
                  <el-option label="31-60天" :value="1"/>
                  <el-option label="61-90天" :value="2"/>
                  <el-option label="90天以上" :value="3"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="截止时间" prop="expirationDate">
                <el-date-picker
                    v-model="clientContract.expirationDate"
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                    placeholder="选择截止时间"
                    :disabled="disabled"/>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-row>
          <el-col :span="7">
            <el-form-item label="收货联系人" prop="customerDeliveryContact">
              <el-input v-model="clientContract.customerDeliveryContact" :disabled="disabled" placeholder="请输入收货联系人"/>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="联系电话" prop="customerDeliveryPhone">
              <el-input
                  v-model="clientContract.customerDeliveryPhone" 
                  type="tel"
                  maxlength="11"
                  :disabled="disabled"
                  placeholder="请输入联系电话"/>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="收货地址" prop="customerAddress">
              <el-input
                  v-model="clientContract.customerAddress"
                  :disabled="disabled || !clientContract.customerId"
                  placeholder="请选择收货地址"
                  readonly>
                <el-button
                    slot="append"
                    icon="el-icon-search"
                    :disabled="disabled || !clientContract.customerId"
                    @click="$refs.addressSelect.open(clientContract.customerId)"/>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div v-if="isCommon || isBorrow" class="editTitle">合同明细</div>
      <el-button
          v-if="isCommon || isBorrow"
          type="primary"
          style="margin-bottom: 10px"
          :disabled="disabled"
          @click="$refs.materialSelect.open(materialFilter)">
        添加物料
      </el-button>
      <el-button
          v-if="isCommon || isBorrow"
          type="primary"
          :disabled="disabled"
          @click="$refs.bomSelect.open()">
        添加BOM
      </el-button>
      <el-table
          v-if="isCommon || isBorrow"
          class="tableBox"
          :data="clientContract.materialList"
          border
          show-summary
          :summary-method="getSummaries">
        <el-table-column
            prop="materialNo"
            align="center"
            label="物料编号"
            width="150"/>
        <el-table-column
            prop="materialName"
            align="center"
            label="物料描述"
            show-overflow-tooltip
            width="360"/>
        <el-table-column
            v-if="clientContract.clientContractType===40"
            prop="refBillNo"
            align="center"
            label="销售单号"
            width="150"/>
        <el-table-column
            v-if="clientContract.clientContractType===40"
            prop="refRowIndex"
            align="center"
            label="销单行项"
            width="100"/>
        <el-table-column
            prop="specification"
            align="center"
            label="规格型号"
            show-overflow-tooltip
            width="200"/>
        <el-table-column
            prop="standardDeliveryTime"
            align="center"
            label="标准交期(天)"
            width="110"/>
        <el-table-column
            prop="quantity"
            align="center"
            label="数量"
            width="100">
          <template slot-scope="scope">
            <el-input v-model="scope.row.quantity" :disabled="disabled" @input="checkQuantity(scope.row)"/>
          </template>
        </el-table-column>
        <el-table-column
            prop="unitPrice"
            align="center"
            label="单价"
            width="100">
          <template slot-scope="scope">
            <el-input v-model="scope.row.unitPrice" :disabled="disabled"/>
          </template>
        </el-table-column>
        <el-table-column
            prop="totalPrice"
            align="center"
            label="总价">
          <template slot-scope="scope">
            <span>{{(scope.row.quantity * scope.row.unitPrice).toFixed(2)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="standardPrice" align="center" label="A价" width="80"/>
        <el-table-column prop="level1Price" align="center" label="B价" width="80"/>
        <el-table-column prop="priceType" align="center" label="价格类型" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.priceType === 10">未定价</span>
            <span v-if="scope.row.priceType === 20">A价</span>
            <span v-if="scope.row.priceType === 30">B价</span>
            <span v-if="scope.row.priceType === 31">C价</span>
            <span v-if="scope.row.priceType === 32">D价</span>
            <span v-if="scope.row.priceType === 40">特价</span>
            <span v-if="scope.row.priceType === 50">一次性特价</span>
            <span v-if="scope.row.priceType === 60">关联公司价格</span>
          </template>
        </el-table-column>
        <el-table-column
            v-if="isBorrow"
            prop="deliveryDate"
            align="center"
            label="期望交期"
            width="200">
          <template slot-scope="scope">
            <el-date-picker
                v-model="scope.row.deliveryDate"
                value-format="yyyy-MM-dd"
                type="date"
                style="width: 100%"
                placeholder="选择交货日期"
                :disabled="disabled"/>
          </template>
        </el-table-column>
        <el-table-column
            v-if="isBorrow"
            prop="oldOrNew"
            align="center"
            label="新/旧机"
            width="150">
          <template slot-scope="scope">
            <el-select v-model="scope.row.oldOrNew" :disabled="disabled">
              <el-option label="新机" :value="0"/>
              <el-option label="旧机" :value="1"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
            prop="note"
            align="center"
            label="备注">
          <template slot-scope="scope">
            <el-input v-model="scope.row.note" :disabled="disabled"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="danger" :disabled="disabled" @click="deleteOne(scope.$index,scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="editTitle">合同附件</div>
      <div style="display: flex;">
        <upload-file
            v-if="limits.uploadAuth"
            ref="upload"
            :auth-index="authIndex"
            btn-name="上传文件"
            @upload-success="(fileList) => {uploadSuccess(fileList, 11)}"/>
        <upload-file
            v-if="limits.uploadAuth"
            ref="upload"
            :auth-index="authIndex"
            btn-name="盖章扫描件"
            @upload-success="(fileList) => uploadSuccess(fileList, 15)"/>
      </div>
      <el-table class="tableBox" :data="clientContract.accessoryList" border>
        <el-table-column label="名称" prop="fileName" width="200">
          <template slot-scope="scope">
            <attachment-viewer :file-path="scope.row.filePath" :file-name="scope.row.fileName"/>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="note"/>
        <el-table-column label="附件类型" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.itemType === 11">合同附件</span>
            <span v-else-if="scope.row.itemType === 15">盖章扫描件</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <down-load-file :file-key="scope.row.filePath"/>
            <el-button type="danger" :disabled="disabled" @click="deleteOneFile(scope.$index,scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="submitHandle">确定</el-button>
    </span>
    <employee-select ref="employeeSelect" @select="onSelectEmployee"/>
    <employee-select ref="employeeSelect1" @select="onSelectEmployee1"/>
    <employee-select ref="employeeSelect2" @select="onSelectEmployee2"/>
    <employee-select ref="applicantSelect" @select="onSelectApplicant"/>
    <customer-select ref="customerSelect" @select="onSelectCustomer"/>
    <customer-select ref="customerSelect1" @select="onSelectCustomer1"/>
    <material-select ref="materialSelect" :is-multi-select="true" @select-change="onSelectMaterial"/>
    <bom-select ref="bomSelect" @select="selectBom"/>
    <client-contract-select ref="clientContractSelect" @select="selectClient"/>
    <address-select ref="addressSelect" @select="onSelectAddress"/>
  </el-dialog>
</template>

<script>

  import EmployeeSelect from "@/views/information/Employee/EmployeeSelect";
  import CustomerSelect from "@/views/information/Customer/CustomerSelect";
  import MaterialSelect from "@/views/information/Material/MaterialSelect";
  import UploadFile from "@/components/UploadFile";
  import DownLoadFile from "@/components/DownLoadFile";
  import BomSelect from "@/views/information/BomManage/BomSelect";
  import ClientContractSelect from "@/views/SalesManage/SalesClientContract/ClientContractSelect";
  import AddressSelect from "@/views/information/Customer/CustomerAddressSelect";
  import AttachmentViewer from "@/components/attachmentViewer";
  import loginUtil from "@/util/loginUtil";

  export default {
    name: "ClientContractEdit",
    components: {
      ClientContractSelect,
      DownLoadFile,
      UploadFile,
      MaterialSelect,
      CustomerSelect,
      EmployeeSelect,
      BomSelect,
      AddressSelect,
      AttachmentViewer,
    },
    data() {
      return {
        disabled: false,
        dialogVisible: false,
        submitLoading: false,
        contentLoading: false,
        isFirstInited: false, // 是否是编辑时的第一次初始化
        isCommon: true,
        isBorrow: false,
        authIndex: this.$route.meta.authIndex,
        limits: {
          editAuth: this.$auth(235),
          downloadAuth: this.$auth(235),
          delAuth: this.$auth(235),
          uploadAuth: this.$auth(235),
        },
        payMethods: [],
        clientContract: {
          pkId: 0,
          clientContractType: 30,
          clientContractName: "",
          urgent: "正常",
          creatorId: loginUtil.getUserId(),
          applicantId: loginUtil.getUserId(),
          applicantName: loginUtil.getName(),
          applicantOaNumber: "",
          salesPersonName: "",
          salesPersonId: "",
          salesPersonDepartment: "",
          sendPeopleId: "",
          createTime: "",
          stampQty: "",
          clientContractNo: "",
          customerClientContractNo: "",
          belongToCustomerNo: "新时达工控技术（杭州）有限公司",
          customerId: "",
          customerNo: "",
          customerName: "",
          finalCustomerNo: "",
          finalCustomerName: "",
          deliveryMessage: "",
          customerDeliveryContact: "",
          customerDeliveryPhone: "",
          customerAddress: "",
          clientContractAmount: "",
          clientContractAmountChinese: "",
          settlementMethod: "",
          creditLimit: "",
          clientContractAbstract: "",
          customerType: "",
          dealerLevel: "",
          commonModel: "",
          framework: "",
          clientContractDeliveryDate: "",
          sourceId: "",
          sourceClientContractNo: "",
          oaProcessNumber: "",
          sendPeopleName: "",
          accessoryList: [],
          materialList: [],
          unifiedSocialCreditCode: "",
          province: "",
          salesTargetProduct: "",
          specificIndustries: "",
          customerSalesPeople: 0,
          customerEngineer: 0,
          customerGuarantor: "",
          guarantorIdNumber: "",
          guarantorAddress: "",
          guarantorPhone: "",
          nextBorrow: false,
          belongToPDTCode: "",
          belongToPDTName: "",
          productTypeCode: "",
          productTypeName: "",
          borrowCompanyCode: "",
          borrowCompanyName: "",
          countersignNumber: "",
          countersignName: "",
          borrowTimeCode: "",
          borrowTimeName: "",
          processorId: "",
          processorName: "",
          processorOA: "",
          expirationDate: "",
          warrantyPeriod:18,
          stampType:117,
          stampNote:2,
          stampNumber:0,
        },
        materialFilter: {
          status: 10,//启用
          priceStatus: 30,//已通过
          noDelistStatus:40,//非停售
        },
        // belongToPDTList: [
        //   {value: 3, name: "BU14泛电子智能产线"},
        //   {value: 4, name: "工业机器人产品线"},
        //   {value: 5, name: "桌面型机器人产品线"},
        //   {value: 0, name: "代理业务"},
        //   {value: 1, name: "国产运控产品线"},
        //   {value: 2, name: "BU10控制及集成"},
        // ],
        ruleValidate: {
          applicantName: {required: true, message: "请选择申请人", trigger: "blur"},
          salesPersonName: {required: true, message: "请选择销售员", trigger: "blur"},
          customerName: {required: true, message: "请选择渠道商/客户", trigger: "blur"},
          urgent: {required: true, message: "请选择紧急程度", trigger: "blur"},
          nextBorrow: {required: true, message: "请选择是否续借", trigger: "blur"},
          belongToPDTCode: {required: true, message: "请选择所属PDT", trigger: "blur"},
          productTypeCode: {required: true, message: "请选择借用产品分类", trigger: "blur"},
          borrowCompanyCode: {required: true, message: "请选择试用品借用公司", trigger: "blur"},
          borrowTimeCode: {required: true, message: "请选择试用时间", trigger: "blur"},
          expirationDate: {required: true, message: "请选择试用截止时间", trigger: "blur"},
          stampType: {required: true, message: "请选择盖章方式", trigger: "blur"},
        },
        salesPersonList: [],
        showSalesPersonSelect: false,
      };
    },
    watch: {
      // 当客户信息改变时需要带出对应的销售员列表信息，如果有值，则展示一个下拉列表并默认赋值第一个销售员，如果没有值，则可以让他选择销售员
      "clientContract.customerId"(val) {
        if(!this.disabled) { // 详情页不用执行相关操作
          if (!val) {
            this.onClearEmployee();
            return;
          }
          // 查询接口
          this.$http.get("basic", `customerEmployees/customerId/${val}`).then(res => {
            if (res.success && Array.isArray(res.data) && res.data.length > 0) {
              this.salesPersonList = res.data;
              this.showSalesPersonSelect = true;
              if(this.isFirstInited) {
                // 编辑第一次初始化的时候，因为原来有值，所以就不自动赋值了
                this.isFirstInited = false;
                return;
              }
              let row = res.data.filter(item =>item.belongType===10 && item.isDefault === true)[0];
              console.log(row);
              this.onSelectEmployee(row);
            } else {
              if(this.isFirstInited) {
                // 编辑第一次初始化的时候，因为原来有值，所以就不执行清空了
                this.isFirstInited = false;
                return;
              }
              this.onClearEmployee();
              this.$message.warning("需要维护所属销售员");
            }
          });
        }
      },
    },
    methods: {
      open(row, mark, form) {
        console.log(row, mark, form);
        this.dialogVisible = true;
        this.disabled = mark;
        if (row) {
          this.isFirstInited = true;
          this.getData(row.pkId);
        } else if (form) {
          this.clientContract=form;
        }
        this.$nextTick(() => {
          this.getPaymentTypes();
        });
      },
      selectBom(row) {
        this.$http.get("basic", `sapBoms/${row.materialNo}`)
          .then((res) => {
            if (res.success) {
              this.bom = res.data;
              console.log(res.data);
              //生成随机6位数
              let random = Math.floor(Math.random() * 1000000);
              let obj = {
                materialId: this.bom.materialId,
                materialNo: this.bom.materialNo,
                materialName: this.bom.materialName,
                specification: this.bom.specification,
                quantity: row.quantity,
                unit: this.bom.unit,
                randomIndex: random,
                manufacturerModel: this.bom.manufacturerModel,
                deliveryDate: this.clientContract.deliveryDate,
                rowType: "虚拟抬头",
              };

              this.clientContract.materialList.push(obj);

              this.bom.bomDetails.forEach((item) => {
                let obj = {
                  materialId: item.partsId,
                  materialNo: item.materialNo,
                  materialName: item.materialName,
                  specification: item.specification,
                  quantity: item.quantity * row.quantity,
                  unit: item.unit,
                  manufacturerModel: item.manufacturerModel,
                  deliveryDate: this.clientContract.deliveryDate,
                  rowType: "销售物料",
                  randomIndex: random,
                };
                this.clientContract.materialList.push(obj);
              });

              this.$http
                .post("basic", "clientContracts/setPrice", this.clientContract)
                .then((resp) => {
                  if (resp.success) {
                    this.clientContract.materialList = resp.data.materialList;
                  }
                })
                .catch(() => {
                  this.clientContract.materialList.splice(this.clientContract.materialList.length - 1, 1);
                });
            }
          }).catch((res) => {
            this.$message.error(res);
          });
        console.log(this.clientContract.materialList);
      },
      onSelectEmployee(row) {
        this.clientContract.salesPerson = {
          employeeID: row.employeeID,
          employeeName: row.employeeName,
          departmentName: row.departmentName,
        };
        this.clientContract.salesPersonId = row.employeeID;
        this.clientContract.salesPersonName = row.employeeName;
        this.clientContract.salesPersonDepartment = row.departmentName;
      },
      // 清空销售员信息
      onClearEmployee() {
        this.salesPersonList = [];
        this.showSalesPersonSelect = false;
        this.clientContract.salesPerson = null;
        this.clientContract.salesPersonId = null;
        this.clientContract.salesPersonName = null;
        this.clientContract.salesPersonDepartment = null;
      },

      onSelectEmployee1(row) {
        this.clientContract.sendPeopleId = row.employeeID;
        this.clientContract.sendPeopleName = row.employeeName;
      },

      onSelectEmployee2(row) {
        this.clientContract.countersignNumber = row.oaNumber;
        this.clientContract.countersignName = row.employeeName;
      },

      onSelectApplicant(row) {
        this.clientContract.applicantId = row.employeeID;
        this.clientContract.applicantName = row.employeeName;
        this.clientContract.applicantOaNumber = row.oaNumber;
      },

      onSelectCustomer(row) {
        this.clientContract.customerNo = row.outerNo;
        this.clientContract.customerName = row.customerName;
        this.clientContract.customerId = row.customerID;
        this.clientContract.settlementMethod = row.zterm;
        if (!this.clientContract.pkId) {
          this.getAddress(this.clientContract.customerNo);
        }
        console.log(this.clientContract);
      },
      onSelectCustomer1(row) {
        this.clientContract.finalCustomerNo = row.outerNo;
        this.clientContract.finalCustomerName = row.customerName;
      },
      getAddress(customerNo) {
        this.$http.get("basic", `customerDeliveryAddress/selectDefaultAddress/${customerNo}`).then((res) => {
          if (res.success) {
            if (res.data != null) {
              this.clientContract.customerDeliveryContact = res.data.contact;
              this.clientContract.customerDeliveryPhone = res.data.telephone;
              this.clientContract.customerAddress = res.data.addressName;
            } else {
              this.clientContract.customerDeliveryContact = "";
              this.clientContract.customerDeliveryPhone = "";
              this.clientContract.customerAddress = "";
            }
          }
        });
      },

      onSelectAddress(row) {
        this.clientContract.customerAddress = row.addressName;
        this.clientContract.customerDeliveryContact = row.contact;
        this.clientContract.customerDeliveryPhone = row.telephone;
      },

      onSelectMaterial(rows) {
        let obj;
        rows.forEach(item => {
          obj = {
            materialId: item.id,
            materialNo: item.no,
            materialName: item.name,
            specification: item.zmyxh,
            quantity: 1,
            unit: item.unit,
            manufacturerModel: item.manufacturerModel,
            standardDeliveryTime: item.standardDeliveryTime,
            deliveryDate: this.clientContract.deliveryDate,
            rowType: "销售物料",
          };
          this.clientContract.materialList.push(obj);
        });
        
        this.$http
          .post("basic", "clientContracts/setPrice", this.clientContract)
          .then((resp) => {
            if (resp.success) {
              this.clientContract.materialList = resp.data.materialList;
            }
          })
          .catch(() => {
            this.clientContract.materialList.splice(this.clientContract.materialList.length - 1, 1);
          });
      },

      // oneSelectPDT(row) {
      // let item = this.belongToPDTList.filter(item => item.value === row);
      // console.log(item);
      // this.clientContract.belongToPDTCode = item.value;
      // this.clientContract.belongToPDTName = item.name;
      // },


      setIsCommon() {
        if (this.clientContract.clientContractType === 30 || this.clientContract.clientContractType === 40) {
          this.isCommon = true;
        } else if (this.clientContract.clientContractType === 50 || this.clientContract.clientContractType === 60) {
          this.isBorrow = true;
        } else {
          this.isCommon = false;
          this.isBorrow = false;
        }
      },

      deleteOne(index) {
        this.clientContract.materialList.splice(index, 1);
      },


      // 获取详情
      getData(pkId) {
        this.contentLoading = true;
        this.$http
          .get("basic", `clientContracts/${pkId}`)
          .then((resp) => {
            if (resp.success) {
              this.clientContract = Object.assign(this.clientContract, resp.data);
              // 申请人默认值：若未填写则为当前登录人
              if (!this.clientContract.applicantName) {
                this.clientContract.applicantId = loginUtil.getUserId();
                this.clientContract.applicantName = loginUtil.getName();
                this.clientContract.applicantOaNumber = "";
              }
              this.clientContract.salesPerson = {
                employeeID: this.clientContract.salesPersonId,
                employeeName: this.clientContract.salesPersonName,
                departmentName: this.clientContract.salesPersonDepartment,
              };
              this.setIsCommon();
            }
            this.contentLoading = false;
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      checkQuantity(row) {
        if (row.quantity === null || row.quantity === undefined || row.quantity === "" || Number(row.quantity) <= 0) {
          this.$message.warning("数量必须大于0");
        }
      },

      submitHandle() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            const invalidQty = (this.clientContract.materialList || []).some(
              (item) => item.quantity === null || item.quantity === undefined || item.quantity === "" || Number(item.quantity) <= 0
            );
            if (invalidQty) {
              this.$message.warning("数量必须大于0");
              return;
            }
            this.submitLoading = true;
            this.$http
              .save("basic", "clientContracts", this.clientContract)
              .then((resp) => {
                this.submitLoading = false;
                console.log(resp);
                if (resp.success) {
                  if (this.clientContract.pkId) {
                    console.log(this.clientContract.pkId);
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  } else {
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },

      uploadSuccess(fileList, type) {
        if (fileList.length) {
          const params = {
            fileName: fileList[0].name,
            filePath: fileList[0].key,
            itemID: this.clientContract.pkId,
            itemType:type,
          };

          this.clientContract.accessoryList.push(params);
          this.$http.post("basic","clientContracts/saveFile",params)
            .then((resp)=>{
              if (resp.success) {
                this.$message.success("文件上传成功");
              }
            });

        }
      },

      deleteOneFile(index) {
        this.clientContract.accessoryList.splice(index, 1);
      },

      // 付款方式
      getPaymentTypes() {
        this.$http.get("basic", "sapSalesOrders/getPaymentType").then((res) => {
          if (res.success) {
            this.payMethods = res.data;
          }
        });
      },

      selectClient(row) {
        this.$http.get("basic", `clientContracts/checkBorrowToSaleQty/${row.pkId}`)
          .then((resp) => {
            if (resp.success) {
              this.clientContract.materialList = resp.data.materialList;
              this.clientContract.sourceClientContractNo = resp.data.clientContractNo;
              this.clientContract.sourceId = resp.data.pkId;
            }
          });
      },

      // 合计行方法
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "合计";
            return;
          }
          if (column.prop === "quantity") {
            sums[index] = data.reduce((prev, curr) => {
              return prev + Number(curr.quantity || 0);
            }, 0);
          } else if (column.label === "总价") {
            sums[index] = data.reduce((prev, curr) => {
              return prev + Number(curr.quantity || 0) * Number(curr.unitPrice || 0);
            }, 0).toFixed(2);
            this.clientContract.clientContractAmount=sums[index];
          } else {
            sums[index] = "";
          }
        });
        return sums;
      },
    },
  };
</script>
